import { useTheme } from '@ankhorage/surface';

export function useZoraTheme() {
  return useTheme();
}
